import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import {
    ThirdPartyPayoff,
    ThirdPartyPayoffDocumentKind,
} from '../../../../models/FlowOfFunds/flow-of-funds.model';

export interface UploadThirdPartyPayoffSupportingDocumentRequest {
    engagementId: number;
    tableRowId: number;
    documentKind: ThirdPartyPayoffDocumentKind;
    file: File;
}

export const UploadThirdPartyPayoffSupportingDocument = createAsyncThunk(
    'flowOfFunds/uploadThirdPartyPayoffSupportingDocument',
    async (
        params: UploadThirdPartyPayoffSupportingDocumentRequest,
        dispatch: any
    ) => {
        const axios = dispatch.getState().core.axios;

        try {
            const formData = new FormData();
            formData.append('File', params.file);
            const temporaryFileResponse = await axios.post(
                `/api/temporaryfiles`,
                formData,
                {
                    headers: { 'Content-Type': 'multipart/form-data' },
                }
            );

            if (temporaryFileResponse.status !== 200) {
                throw new Error('Failed to upload the supporting document');
            }

            const response = await axios.put(
                `/api/flowOfFunds/${params.engagementId}/thirdPartyPayoffs/rows/${params.tableRowId}/documents/${params.documentKind}`,
                {
                    temporaryFileId: temporaryFileResponse.data.id,
                    pageCount: null,
                }
            );

            if (response.status !== 200) {
                throw new Error('Failed to save the supporting document');
            }

            return response.data as ThirdPartyPayoff;
        } catch (error) {
            createNotification(
                'Could not upload the supporting document.',
                'error'
            );
            throw error;
        }
    }
);
